import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { EitherLearningCollectionStore, getOfferingTypesFor } from '../../../Types';
import Utilization from './Utilization';
import ProductLicense from './Utilization/ProductLicense';

export interface PlacementProps {
  marginTop?: string;
  marginRight?: string;
  position?: { absolute?: boolean; top?: string; right?: string };
}

interface Props {
  store: EitherLearningCollectionStore;
  placementProps?: PlacementProps;
}

function UtilizationBanner({ store, placementProps }: Props) {
  switch (store.state.kind) {
    case 'choosing-product-license':
      return <ProductLicense store={store} />;
    case 'choosing-learning-designs':
    case 'previewing':
    case 'sharing':
    case 'editing-details':
    case 'saving-details':
    case 'building':
    case 'adding-learning-design':
    case 'deleting-section':
    case 'creating':
    case 'updating':
      const { state } = store;
      return state.selectedProductLicense
        .map((productLicense) => (
          <Utilization
            productLicense={productLicense}
            learningDesignOfferingTypes={getOfferingTypesFor(store, state)}
            placementProps={placementProps}
          />
        ))
        .getOrElseValue(emptyFragment());
    case 'reload-all-experiences':
    case 'edit-form-submission-error':
    case 'loading-for-deep-links':
    case 'finished':
    case 'finishing':
    case 'load-error':
    case 'loading-for-invitations':
    case 'new-form-submission-error':
    case 'previewing-updating':
    case 'updating-product-license':
    case 'ready':
    case 'ready-deep-links':
    case 'ready-invitations':
    case 'waiting':
    case 'loading':
      return emptyFragment();
  }
}

export default observer(UtilizationBanner);
